import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

// Module-level cache — one fetch per page load
let _cache = null;
let _promise = null;

async function loadAvailability() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = (async () => {
    try {
      const { data } = await api.get("/staff?role=doctor");
      const map = {};
      (data || []).forEach((d) => { map[d.name] = d.availability || "in_clinic"; });
      _cache = map;
      return map;
    } catch {
      _cache = {};
      return {};
    }
  })();
  return _promise;
}

/** Reset the cache — call after any mutation that could change availability (e.g., a doctor sets Off). */
export function refreshDoctorAvailability() { _cache = null; _promise = null; }

const TONES = {
  in_clinic: { color: "bg-emerald-500", ring: "ring-emerald-300", title: "In clinic" },
  on_call:   { color: "bg-amber-500",   ring: "ring-amber-300",   title: "On call" },
  off:       { color: "bg-slate-400",   ring: "ring-slate-200",   title: "Off duty" },
};

/** Small colored dot for a doctor's availability, keyed by their display name. */
export function DoctorAvailabilityDot({ name, className = "" }) {
  const [av, setAv] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      const map = await loadAvailability();
      if (alive) setAv(map[name] || null);
    })();
    return () => { alive = false; };
  }, [name]);
  if (!name || !av) return null;
  const t = TONES[av] || TONES.in_clinic;
  return (
    <span
      title={`${name} · ${t.title}`}
      data-testid={`doc-avail-dot-${av}`}
      className={`inline-block w-2.5 h-2.5 rounded-full ${t.color} ring-2 ${t.ring} ${className}`}
    />
  );
}
